"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SemanticAttributes = void 0;
var SemanticAttributes;
(function (SemanticAttributes) {
    SemanticAttributes["strong"] = "strong";
    SemanticAttributes["emphasized"] = "emphasized";
    SemanticAttributes["small"] = "small";
    SemanticAttributes["subscript"] = "subscript";
    SemanticAttributes["superscript"] = "superscript";
    SemanticAttributes["underlined"] = "underlined";
    SemanticAttributes["quoted"] = "quoted";
})(SemanticAttributes = exports.SemanticAttributes || (exports.SemanticAttributes = {}));
